import type { TimelineData } from '@/core/types/contracts';

/** Timeline data registry keyed by id. Chapter builders register their JSON here. */
export const TIMELINES: Record<string, TimelineData> = {};
export function registerTimelines(list: TimelineData[]): void { for (const t of list) TIMELINES[t.id] = t; }
export function getTimeline(id: string): TimelineData | undefined { return TIMELINES[id]; }
